import { END_POINTS } from "../constants/url";
import emptySplitApi from "../utils/rtk";

interface CommonResponseType {
  statusCode: number;
  message: string;
}

export const BlogApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    addBlog: builder.mutation<CommonResponseType, any>({
      query: (body) => ({
        url: END_POINTS.blog,
        method: "POST",
        body,
      }),
    }),
    getBlog: builder.query<
      CommonResponseType & {
        data: {
          data: any[];
          total: number;
        };
      },
      {
        from: number;
        size: number;
        search: string;
      }
    >({
      query: ({ from, size, search }) => ({
        url:
          `${END_POINTS.blog}?from=${from}&size=${size}` +
          (search?.length ? `&search=${search}` : ""),
        method: "GET",
      }),
    }),
    getBlogDetail: builder.query<
      CommonResponseType & {
        data: any;
      },
      {
        id: string;
      }
    >({
      query: ({ id }) => ({
        url: `${END_POINTS.blog}/${id}`,
        method: "GET",
      }),
    }),
    updateBlog: builder.mutation<
      CommonResponseType & { data: any },
      { body: any; id: string }
    >({
      query: ({ body, id }) => ({
        url: `${END_POINTS.blog}/${id}`,
        method: "PUT",
        body,
      }),
    }),
    deleteBlog: builder.mutation<CommonResponseType, { id: string }>({
      query: ({ id }) => ({
        url: `${END_POINTS.blog}/${id}`,
        method: "DELETE",
      }),
    }),
  }),
});

export const {
  useAddBlogMutation,
  useLazyGetBlogQuery,
  useLazyGetBlogDetailQuery,
  useUpdateBlogMutation,
  useDeleteBlogMutation,
} = BlogApi;
